import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
	GetNotificationByIdResponse,
	GetNotificationStatsResponse,
	GetPagedNotificationsResponse,
	NotificationApiMessageCenterApiService
} from '../_AUTOGENERATED_';
import { GetNotifications$Params } from '../_AUTOGENERATED_/fn/notification-api-message-center/get-notifications';
import { PostNotifications$Params } from '../_AUTOGENERATED_/fn/notification-api-message-center/post-notifications';

@Injectable({
	providedIn: 'root'
})
export class NotificationsApiService {
	constructor(private notificationsApiService: NotificationApiMessageCenterApiService) {}

	/**
	 * Marks notifications as read, archived, or trashed.
	 *
	 * @param requestData Notification update request payload.
	 * @returns Observable that completes when update succeeds.
	 */
	public postNotifications(requestData: PostNotifications$Params): Observable<void> {
		return this.notificationsApiService.postNotifications(requestData);
	}

	/**
	 * Retrieves a notification by identifier
	 *
	 * @param notificationId Notification identifier.
	 * returns Notification details.
	 **/
	public getNotification(notificationId: string): Observable<GetNotificationByIdResponse> {
		return this.notificationsApiService.getNotification({
			notificationId
		});
	}

	/**
	 * Retrieves notification statistics.
	 *
	 * @returns Notification statistics.
	 */
	public getNotificationStats(): Observable<GetNotificationStatsResponse> {
		return this.notificationsApiService.getNotificationStats();
	}

	/**
	 * Retrieves paginated notifications.
	 *
	 * @param params Notification query parameters.
	 * @returns Paginated notification list.
	 */
	public getNotifications(params?: GetNotifications$Params): Observable<GetPagedNotificationsResponse> {
		return this.notificationsApiService.getNotifications(params);
	}

	/**
	 * Empties the trash folder
	 *
	 * @returns Observable that completes when trash is emptied.
	 */
	public emptyTrash(): Observable<void> {
		return this.notificationsApiService.emptyTrashNotifications();
	}
}
